import { SplitNodeV2Data } from "src/constants/NodeDataTypes";
import {
  FindBranchNodeFn,
  SearchableField,
} from "src/flowGraph/canvasSearch/extractNodeFields";
import { extractClauses } from "src/flowGraph/canvasSearch/nodesExtractors/utils";

export const extractSplitNodeFields = (
  data: SplitNodeV2Data,
  _nodeId: string,
  findBranchNode: FindBranchNodeFn,
): SearchableField[] => {
  const searchableBranches = data.branches.flatMap(({ clauses, edge_id }) => {
    const searchableClauses = extractClauses(clauses);
    const branchNode = findBranchNode?.(edge_id);
    const branchField = branchNode
      ? [
          {
            id: edge_id,
            value: branchNode.data.label,
          },
        ]
      : [];

    return [...searchableClauses, ...branchField];
  });

  return searchableBranches;
};
